import React, { createContext, useContext, ReactNode } from 'react';
import { MeetingMainConfig } from '../type';

// 定义 Context 类型（status 可能为 undefined，需兼容）
type MeetingConfigContextType = {
  // 是否外网服务
  isExternalDomain: boolean;
  mainConfig: MeetingMainConfig;
};

// 创建 Context，默认值为 undefined（需显式声明类型）
const MeetingConfigContext = createContext<
  MeetingConfigContextType | undefined
>(undefined);

// 自定义 Hook，简化子组件获取 status 的方式
export const useMeetingStatus = () => {
  const context = useContext(MeetingConfigContext);
  if (context === undefined) {
    throw new Error('useMeetingStatus 必须在 MeetingStatusProvider 内部使用');
  }
  return context.mainConfig.status;
};
export const useMeetingConfig = () => {
  const context = useContext(MeetingConfigContext);
  if (context === undefined) {
    throw new Error('useMeetingConfig 必须在 MeetingStatusProvider 内部使用');
  }
  return context.mainConfig;
};
// 自定义 Hook，简化子组件获取 isExternalDomain 的方式
export const useIsExternalDomain = () => {
  const context = useContext(MeetingConfigContext);
  if (context === undefined) {
    throw new Error(
      'useIsExternalDomain 必须在 MeetingStatusProvider 内部使用'
    );
  }
  return context.isExternalDomain;
};

// Provider 组件，接收 children 和 status 作为 props
interface MeetingConfigProviderProps {
  children: ReactNode;
  isExternalDomain: boolean;
  mainConfig: MeetingMainConfig;
}

export const MeetingConfigProvider: React.FC<MeetingConfigProviderProps> = ({
  children,
  mainConfig,
  isExternalDomain = false,
}) => {
  return (
    <MeetingConfigContext.Provider value={{ isExternalDomain, mainConfig }}>
      {children}
    </MeetingConfigContext.Provider>
  );
};
